import React from 'react';
import './Apply.css';
import Header from '../components/header';
import Footer from '../components/Footer';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const ApplyPC = () => {
  return (
    <div className="apply-container">
      <Header />
      <main className="apply-main mt-36">
        <div className="apply-form-container">
          <h1 className="apply-title">参加申し込みフォーム</h1>
          <br />
          <section className="apply-info">
            <h2 className="apply-subtitle">申し込み方法</h2>
            <p className="apply-description">
              以下のGoogleフォームリンクから以下の項目を入力ください。<br />
              <br />・お名前（必須）
              <br />・ご連絡手段（必須）
              <br />・ご連絡先（必須）
              <br />・大学ご入学年（必須）
              <br />・希望パート（必須）
              <br />・ご住まいの都道府県（任意）
              <br />・出身大学（任意）
              <br />・その他ご質問（任意）
            </p>
          </section>
          <section className="apply-deadline">
            <h3 className="apply-subtitle">申し込み期限</h3>
            <p className="apply-date">演奏会当日まで募集しております。</p>
          </section>
          <br />

          {/* Google Form Embed for PC with increased height */}
          <iframe 
            src="https://docs.google.com/forms/d/e/1FAIpQLSewsVYXxAHT_Ugui_V_0cIpc8lBn-kEK1zBRPBYG4iuRTJ7Qg/viewform?usp=sf_link" 
            width="100%" 
            height="2200px" 
            frameBorder="0" 
            marginHeight="0" 
            marginWidth="0">
            Loading…
          </iframe>
        </div>
      </main>
      <Footer /> 
    </div>
  );
}

const ApplyMobile = () => {
  return (
    <div className="apply-container">
      <Header />
      <main className="apply-main mt-36">
        <h1 className="apply-title">参加申し込み</h1>
        <br />
        <section className="apply-info">
          <h2 className="apply-subtitle">申し込み方法</h2>
          <p className="apply-description">
            以下のGoogleフォームリンクから以下の項目を入力ください。<br />
            <br />・お名前（必須）
            <br />・ご連絡手段（必須）
            <br />・ご連絡先（必須）
            <br />・大学ご入学年（必須）
            <br />・希望パート（必須）
            <br />・ご住まいの都道府県（任意）
            <br />・出身大学（任意）
            <br />・その他ご質問（任意）
          </p>
        </section>
        <section className="apply-deadline">
          <h3 className="apply-subtitle">申し込み期限</h3>
          <p className="apply-date">演奏会当日まで募集しております。</p>
          <br></br>
          <p className="apply-date">※ 下へ行く際は、<br />  左右の余白をスクロールしてください</p>
        </section>

        {/* Google Form Embed for Mobile with increased height */}
        <iframe 
          src="https://docs.google.com/forms/d/e/1FAIpQLSewsVYXxAHT_Ugui_V_0cIpc8lBn-kEK1zBRPBYG4iuRTJ7Qg/viewform?usp=sf_link" 
          width="100%" 
          height="2200px" 
          frameBorder="0" 
          marginHeight="0" 
          marginWidth="0">
          Loading…
        </iframe>
      </main>
      <Footer /> 
    </div>
  );
}

function Apply() {
  return isMobile ? <ApplyMobile /> : <ApplyPC />;
}

export default Apply;
